<template>
    <div
        class="py-2 pl-3 pr-1.5 flex justify-between items-center font-bold text-xs text-slate-700 border-b-slate-200 border-b min-h-[41px]"
    >
        <div class=""><slot> </slot></div>
        <vx-button
            v-if="props.canReset"
            data-test="reset-from-title"
            size="xs"
            color="transparent"
            @click.prevent="emit('reset')"
            type="button"
        >
            <span class="text-[10px]">
                <font-awesome-icon widthAuto :icon="faUndo"></font-awesome-icon>
            </span>
        </vx-button>
    </div>
</template>

<script lang="ts" setup>
import { faUndo } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { VxButton } from '@voxie/frontend-components';

const props = defineProps({
    canReset: {
        type: Boolean,
        default: false,
    },
});

const emit = defineEmits(['reset']);
</script>
